import { render, staticRenderFns } from "./MetadataRecord.vue?vue&type=template&id=120454ef&scoped=true&"
import script from "./MetadataRecord.vue?vue&type=script&lang=js&"
export * from "./MetadataRecord.vue?vue&type=script&lang=js&"
import style0 from "./MetadataRecord.vue?vue&type=style&index=0&id=120454ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120454ef",
  null
  
)

component.options.__file = "MetadataRecord.vue"
export default component.exports